import { Component, OnInit, Input } from '@angular/core';
import { OrderingService } from '../../../../../services';

@Component({
  selector: '[order-discount]',
  templateUrl: './order-discount.component.html',
  styleUrls: ['./order-discount.component.css']
})
export class OrderDiscountComponent implements OnInit {
  @Input()product;
  @Input()order;
  @Input()discount;

  constructor(
    private orderingService: OrderingService
  ) { }

  ngOnInit() {
  }

}
